<template>
  <div class="fs-background fs-background--fullscreen">
    <div class="form-container form-container--floating">
      <div class="logo logo--wcz" />

      <h2 class="primary--text mb-4">Inloggen bij Mijn Zonnepanelen</h2>

      <v-form ref="form" v-model="valid">
        <v-text-field
          autocomplete="email"
          solo
          id="txtEmail"
          v-model="email"
          :rules="rules.email"
          prepend-icon="fa-envelope"
          v-bind:disabled="isAuthenticating"
          :label="$t('forms.email')"
          required
        ></v-text-field>

        <v-text-field
          autocomplete="current_password"
          solo
          id="txtPassword"
          v-model="password"
          :rules="passwordRule"
          prepend-icon="fa-lock"
          :type="showPassword ? 'text' : 'password'"
          v-bind:disabled="isAuthenticating"
          @click:append="showPassword = !showPassword"
          :append-icon="showPassword ? 'far fa-eye-slash' : 'far fa-eye'"
          :label="$t('forms.password')"
          required
        ></v-text-field>

        <div class="actions">
          <v-btn
            class="lowercase ma-0"
            @click="signIn"
            id="btnLogin"
            v-bind:loading="isAuthenticating"
            color="primary"
            v-bind:disabled="isAuthenticating"
            v-t="'buttons.login'"
          >
          </v-btn>
          <v-btn
            class="hyperlink lowercase mx-0 mb-0"
            flat
            text
            color="primary"
            to="/wachtwoord-herstellen"
            v-t="'buttons.forgotPassword'"
          >
          </v-btn>
          <v-btn
            class="hyperlink lowercase ma-0"
            flat
            text
            color="primary"
            to="/registreren"
            v-t="'buttons.noAccount'"
          >
          </v-btn>
          <v-btn
            class="hyperlink lowercase ma-0"
            flat
            text
            color="primary"
            href="https://wocozon.nl/mijn-zonnepanelen-uitleg/?utm_source=mijnzonnepanelen&utm_medium=inloguitleg&utm_campaign=ks"
            v-t="'Uitleg'"
            target="_blank"
          >
          </v-btn>
          <v-btn
            class="hyperlink lowercase ma-0"
            flat
            text
            color="primary"
            href="https://wocozon.nl/contact/?utm_source=mijnzonnepanelen&utm_medium=inlogcontact&utm_campaign=ks"
            v-t="'Contact'"
            target="_blank"
          >
          </v-btn>
        </div>
      </v-form>

      <v-alert dismissible :value="error" type="error" outline class="alert-style">
        <msp-api-error :response="error" />
      </v-alert>
    </div>
  </div>
</template>

<script>
import { rules } from "@/helpers/forms";
import { $t } from "@/plugins/i18n";

export default {
  data() {
    return {
      error: null,
      valid: false,
      showPassword: false,
      email: "",
      password: "",
      rules,
      passwordRule: [(v) => !!v || $t("validation.password.required")],
    };
  },

  created() {
    // Use a timeout because of a likely racing condition with restoring persisted state
    setTimeout(() => this.$store.dispatch("account/setAdmin", this.isAdmin));
  },

  mounted() {
    this.error = null;
  },

  computed: {
    isAuthenticating() {
      return this.$store.state.account.isAuthenticating;
    },

    isAuthenticated() {
      return this.$store.state.account.isAuthenticated;
    },

    isAdmin() {
      return this.$store.state.account.isAdmin;
    },
  },
  methods: {
    async signIn() {
      if (this.$refs.form.validate()) {
        try {
          this.error = null;
          await this.$store.dispatch("account/signIn", {
            email: this.email,
            password: this.password,
          });

          if (this.isAdmin) {
            await this.$router.replace("/inloggen/als");
          } else {
            await this.$router.replace("/dashboard");
          }
        } catch (error) {
          this.error = error;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.fs-background {
  &--fullscreen {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
  }

  &:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-size: cover;
    background-position: center center;
    background-image: url("../assets/logos/wocozon_couple_cropped.png");
  }
}

.login {
  &__logo {
    background-image: url("../assets/logos/logo.png");
    position: absolute;
    background-size: contain;
    right: -15px;
    top: -15px;
    width: 150px;
    height: 60px;
  }
}

.form-container {
  width: 100%;
  box-shadow: 0 0 4px rgba(#000, 0.7);
  padding: 30px 15px;
  display: flex;
  align-items: center;
  flex-direction: column;

  &--floating {
    padding: 30px 15px;
    @media (min-width: 960px) {
      padding: 60px 15px;
    }
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(#000, 0.2);
  }

  .v-alert {
    margin-top: 24px;
  }

  form {
    width: 100%;
    max-width: 400px;
  }
}

.signin__welcome {
  max-width: 400px;
  margin-bottom: 32px;
  padding-left: 32px;
}
</style>

<style lang="scss" scoped>
.actions {
  display: flex;
  flex-direction: column;
  text-transform: none;
}

.hyperlink {
  text-decoration: underline;
}

.lowercase {
  text-transform: none;
}

.signup {
  margin-top: 20px;
}

.logo--wcz {
  margin-bottom: 30px;
  height: 100px;
  width: 300px;
}

.v-alert {
  max-width: 600px;
}

.hr {
  width: 100%;
  opacity: 0.3;
  margin-bottom: 4px;
}
</style>
